"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _palette = _interopRequireDefault(require("cccisd-icons/palette"));
var _paperplane = _interopRequireDefault(require("cccisd-icons/paperplane"));
var _meterMedium = _interopRequireDefault(require("cccisd-icons/meter-medium"));
var _listNumbered = _interopRequireDefault(require("cccisd-icons/list-numbered"));
var _fileSpreadsheet = _interopRequireDefault(require("cccisd-icons/file-spreadsheet2"));
var _userLock = _interopRequireDefault(require("cccisd-icons/user-lock"));
var _cog = _interopRequireDefault(require("cccisd-icons/cog2"));
var _statsBars = _interopRequireDefault(require("cccisd-icons/stats-bars2"));
var _NavLink = _interopRequireDefault(require("./NavLink"));
var _questPermissionsByArea = _interopRequireDefault(require("../../helpers/questPermissionsByArea.js"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Fortress = window.cccisd.fortress;
var IconSpace = function IconSpace(_ref) {
  var iconComponent = _ref.iconComponent;
  var IconComponent = iconComponent;
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: _style["default"].iconSpace
  }, /*#__PURE__*/_react["default"].createElement(IconComponent, null));
};
var _default = exports["default"] = function _default(_ref2) {
  var project = _ref2.project;
  return /*#__PURE__*/_react["default"].createElement("ul", {
    className: "nav nav-tabs",
    style: {
      marginBottom: '1em'
    }
  }, Fortress.hasAnyAccess(_questPermissionsByArea["default"].design.permissions, 'anyTarget') && /*#__PURE__*/_react["default"].createElement(_NavLink["default"], {
    to: "/quest/".concat(project.groupId, "/design"),
    disabled: !Fortress.hasAnyAccess(_questPermissionsByArea["default"].design.permissions, project.groupId)
  }, /*#__PURE__*/_react["default"].createElement(IconSpace, {
    iconComponent: _palette["default"]
  }), "Design"), Fortress.hasAnyAccess(_questPermissionsByArea["default"].deploy.permissions, 'anyTarget') && /*#__PURE__*/_react["default"].createElement(_NavLink["default"], {
    to: "/quest/".concat(project.groupId, "/deploy"),
    disabled: !Fortress.hasAnyAccess(_questPermissionsByArea["default"].deploy.permissions, project.groupId)
  }, /*#__PURE__*/_react["default"].createElement(IconSpace, {
    iconComponent: _paperplane["default"]
  }), "Deploy"), Fortress.hasAnyAccess(_questPermissionsByArea["default"].status.permissions, 'anyTarget') && /*#__PURE__*/_react["default"].createElement(_NavLink["default"], {
    to: "/quest/".concat(project.groupId, "/status"),
    disabled: !Fortress.hasAnyAccess(_questPermissionsByArea["default"].status.permissions, project.groupId)
  }, /*#__PURE__*/_react["default"].createElement(IconSpace, {
    iconComponent: _meterMedium["default"]
  }), "Progress"), Fortress.hasAnyAccess(_questPermissionsByArea["default"].code.permissions, 'anyTarget') && /*#__PURE__*/_react["default"].createElement(_NavLink["default"], {
    to: "/quest/".concat(project.groupId, "/code"),
    disabled: !Fortress.hasAnyAccess(_questPermissionsByArea["default"].code.permissions, project.groupId)
  }, /*#__PURE__*/_react["default"].createElement(IconSpace, {
    iconComponent: _listNumbered["default"]
  }), "Code"), Fortress.hasAnyAccess(_questPermissionsByArea["default"].data.permissions, 'anyTarget') && /*#__PURE__*/_react["default"].createElement(_NavLink["default"], {
    to: "/quest/".concat(project.groupId, "/data"),
    disabled: !Fortress.hasAnyAccess(_questPermissionsByArea["default"].data.permissions, project.groupId)
  }, /*#__PURE__*/_react["default"].createElement(IconSpace, {
    iconComponent: _fileSpreadsheet["default"]
  }), "Data"), Fortress.hasAnyAccess(_questPermissionsByArea["default"].permissions.permissions, 'anyTarget') && /*#__PURE__*/_react["default"].createElement(_NavLink["default"], {
    to: "/quest/".concat(project.groupId, "/permissions"),
    disabled: !Fortress.hasAnyAccess(_questPermissionsByArea["default"].permissions.permissions, project.groupId)
  }, /*#__PURE__*/_react["default"].createElement(IconSpace, {
    iconComponent: _userLock["default"]
  }), "Permissions"), Fortress.hasAnyAccess(_questPermissionsByArea["default"].manage.permissions, 'anyTarget') && /*#__PURE__*/_react["default"].createElement(_NavLink["default"], {
    to: "/quest/".concat(project.groupId, "/projects")
  }, /*#__PURE__*/_react["default"].createElement(IconSpace, {
    iconComponent: _cog["default"]
  }), "Manage Projects"), (Fortress.settings.permissions.find(function (item) {
    return item.includes('quest.admin');
  }) || Fortress.isSuperUser()) && /*#__PURE__*/_react["default"].createElement(_NavLink["default"], {
    to: "/quest/".concat(project.groupId, "/usage")
  }, /*#__PURE__*/_react["default"].createElement(IconSpace, {
    iconComponent: _statsBars["default"]
  }), "Usage"));
};